import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Troubleshooting = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.875 4.458a7.126 7.126 0 0 0-7.072 6.25h-1.51a8.626 8.626 0 1 1 15.188 6.42l4.05 4.05a.75.75 0 1 1-1.061 1.06l-4.05-4.049a8.6 8.6 0 0 1-5.545 2.019 8.61 8.61 0 0 1-6.938-3.5h1.988a7.125 7.125 0 1 0 4.95-12.25m-5.148 9.486 1.574-2.833 1.263 4.105c.282.917 1.568.95 1.896.048l1.097-3.019.608 1.419a1 1 0 0 0 1.626.313l.74-.739a.75.75 0 1 0-1.061-1.06l-.217.216-.815-1.9c-.357-.834-1.549-.8-1.859.051l-1.02 2.805-1.17-3.802c-.259-.842-1.402-.962-1.83-.191l-2 3.601H2a.75.75 0 0 0 0 1.5h3.853a1 1 0 0 0 .874-.514'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.875 4.458a7.126 7.126 0 0 0-7.072 6.25h-1.51a8.626 8.626 0 1 1 15.188 6.42l4.05 4.05a.75.75 0 1 1-1.061 1.06l-4.05-4.049a8.6 8.6 0 0 1-5.545 2.019 8.61 8.61 0 0 1-6.938-3.5h1.988a7.125 7.125 0 1 0 4.95-12.25m-5.148 9.486 1.574-2.833 1.263 4.105c.282.917 1.568.95 1.896.048l1.097-3.019.608 1.419a1 1 0 0 0 1.626.313l.74-.739a.75.75 0 0 0-1.061-1.06l-.217.216-.815-1.9c-.357-.834-1.549-.8-1.859.051l-1.02 2.805-1.17-3.802c-.259-.842-1.402-.962-1.83-.191l-2 3.6H2a.75.75 0 0 0 0 1.5h3.853a1 1 0 0 0 .874-.513'
        fill='currentColor'
      />
    )}
  </IconBase>
);
